/* eslint-disable camelcase */
import { Maybe, Optional } from 'types';

export type FormValues = {
    title: string;
    titleFront: Maybe<string>;
    description: string;
    descriptionFront: Maybe<string>;
    articleUrl: Maybe<string>;
    category: {
        id: Maybe<number>;
    };
    playback: Maybe<{
        begin: number;
        end: Maybe<number>;
    }>;
    flightTimes: {
        start: number;
        end: Maybe<number>;
    };
    // null indicates asset schedule should be deleted
    schedulePublishTime: Maybe<number> | undefined;
    additional: {
        tags: string[];
        stories: string[];
        settings: {
            source: Maybe<number>;
            showAds: boolean;
            showInNewest: boolean;
            notes: Maybe<string>;
            ageLimit: Maybe<number>;
        };
        chapters: { title: string; timeline: number }[];
        metadata: {
            simpleMetadata: { key: string; value: string }[];
            multiPreviewsMetadata: { [key: string]: string };
            isPodcast: boolean;
            distributeAfter: Optional<string>;
            podcast_guid: Optional<string>;
            podcast_episodeType: Optional<string>;
            tts_disabled: boolean;
            contentType: Optional<string>;
            mood: Optional<string>;
            silentplay: boolean;
            drmPlaybackEnabled: boolean;
            newsLifetime: Optional<string>;
            newsValue: Optional<string>;
            studioStartTime: Optional<string>;
            eventStartTime: Optional<string>;
            richDescription: Optional<string>;
            disableNextVideo: boolean;
            bylineName: Optional<string>;
            bylineEmail: Optional<string>;
            authors: Optional<string[]>;
            movie_cast: Optional<string[]>;
            movie_director: Optional<string>;
            movie_releasedAt: Optional<string>;
            livingThumbnail: boolean;
            seoTitle: Optional<string>;
            seoDescription: Optional<string>;
            titleShortPath: string;
            disableReactions: boolean;
            enableComments: boolean;
            lockCommenting: boolean;
            horizontalAssetId: string;
            enableBigScreenButton: boolean;
        };
        subtitles?: {
            language: string;
            url: string;
            default: boolean;
        }[];
        cuePoints:
            | {
                  timeline: number;
              }[]
            | undefined;
    };
    series: {
        seasonNumber: Maybe<number>;
        episodeNumber: Maybe<number>;
    };
    streamUrls: {
        hls: string;
    };
    protections: {
        geoRestriction: boolean;
        accessLevel: string;
    };
    sendToPodme: boolean;
    images: {
        main: string;
        featured: string;
        front: string;
    };
    pushNotifications: {
        send: boolean;
        content: Maybe<string>;
        time: Maybe<number>;
    };
};

export interface SubmitOptions {
    shouldBackToLive: boolean;
    isDynamicField?: (key: string) => boolean;
}

export const IMAGE_TYPES = ['main', 'featured', 'front'] as const;

export type ImageType = (typeof IMAGE_TYPES)[number];
